import { Text, VStack } from '@chakra-ui/react';
import { MdFingerprint, MdSecurity, MdVpnKey } from 'react-icons/md';
import ChangePasswordCustomer from '../components/ChangePasswordCustomer';
import DeleteAccount from '../components/DeleteAccount';
import Enable2FA from '../Enable2FA';
import EnableSafeCode from '../components/EnableSafeCode';
import SectionCard from './SectionCard';

interface SecurityTabProps {
  masterPasswordEnabled?: boolean;
  twoFaEnabled?: boolean;
  loaded: boolean;
}

export default function SecurityTab({ masterPasswordEnabled, twoFaEnabled, loaded }: SecurityTabProps) {
  return (
    <VStack
      spacing={4}
      align="stretch"
    >
      <SectionCard
        title="Senha"
        icon={MdVpnKey}
      >
        <ChangePasswordCustomer />
      </SectionCard>

      <SectionCard
        title="Senha Mestre"
        icon={MdSecurity}
      >
        <Text
          fontSize="sm"
          color="gray.600"
          mb={3}
        >
          A senha mestre é uma camada extra de segurança para sua conta. Será solicitada sempre que você realizar uma
          transação de risco.
        </Text>
        {loaded && <EnableSafeCode isEnabled={masterPasswordEnabled} />}
      </SectionCard>

      <SectionCard
        title="Autenticação em Dois Fatores (2FA)"
        icon={MdFingerprint}
      >
        <Text
          fontSize="sm"
          color="gray.600"
          mb={3}
        >
          A autenticação de dois fatores é uma camada extra de segurança para autenticar sua conta.
        </Text>
        {loaded && !twoFaEnabled && <Enable2FA />}
        {loaded && twoFaEnabled && (
          <Text
            color="green.500"
            fontWeight="semibold"
          >
            2FA de autenticação ATIVADO
          </Text>
        )}
      </SectionCard>

      <DeleteAccount />
    </VStack>
  );
}
